/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import axios from 'axios';

export const fetchGeoIPData = () => axios.get('https://ipapi.co/json').then((response) => response.data);
export default {};
